import { useCreation, usePersistFn } from '@euler/utils/hooks';
import { useCallback, useRef, useState } from 'react';
import { LayoutChangeEvent, LayoutRectangle } from 'react-native';
import { Subject } from 'rxjs';

export const useLayout = (handler?: (e: LayoutChangeEvent) => void) => {
  const [layout, setLayout] = useState<LayoutRectangle>();

  const layoutRef = useRef<LayoutRectangle>();
  const layoutChange$ = useCreation(() => new Subject<LayoutRectangle>(), []);

  const customHandler = usePersistFn((e: LayoutChangeEvent) => {
    handler?.(e);
  });

  const onLayout = useCallback(
    (e: LayoutChangeEvent) => {
      if (
        layoutRef.current?.x !== e.nativeEvent.layout.x ||
        layoutRef.current?.y !== e.nativeEvent.layout.y ||
        layoutRef.current?.width !== e.nativeEvent.layout.width ||
        layoutRef.current?.height !== e.nativeEvent.layout.height
      ) {
        layoutRef.current = e.nativeEvent.layout;
        setLayout(e.nativeEvent.layout);
        layoutChange$.next(e.nativeEvent.layout);
        layoutChange$.next(e.nativeEvent.layout);
        customHandler?.(e);
      }
    },
    [customHandler, layoutChange$],
  );

  return [layout, onLayout, layoutChange$, layoutRef] as const;
};
